<template>
    <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <filter id="w4tie4a6ua">
                <feColorMatrix in="SourceGraphic" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"/>
            </filter>
        </defs>
        <g transform="translate(-1418 -129)" filter="url(#w4tie4a6ua)" fill="none" fill-rule="evenodd" stroke-linecap="round">
            <g fill="#043D89" fill-rule="nonzero" stroke="#043D89" stroke-width="3">
                <path d="m1420.728 131.728 20.752 20.752M1441.48 131.728l-20.752 20.752"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconCloseWhite",
};
</script>
